import { useCallback, useRef } from 'react';
const useInfiniteLoading = function () {
  let hasMore = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
  let loadMore = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : () => {};
  let loading = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
  let {
    root = null,
    rootMargin = '0px',
    threshold = 0
  } = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
  const observer = useRef(null);
  const disconnect = useCallback(() => {
    if (observer.current) {
      observer.current.disconnect();
    }
  }, [observer.current]);
  const measureRef = useCallback(node => {
    if (hasMore && node && !loading) {
      observer.current = new IntersectionObserver(_ref => {
        let [entry] = _ref;
        if (entry.isIntersecting) {
          loadMore(entry, observer, node);
        }
      }, {
        root,
        rootMargin,
        threshold
      });
      observer.current?.observe(node);
    } else {
      disconnect();
    }
  }, [root, rootMargin, threshold, disconnect, loadMore, hasMore, loading]);
  return {
    measureRef,
    observer
  };
};
export default useInfiniteLoading;